module.exports = __webpack_public_path__ + "10_hige_black.6e9f601b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/10_hige_black.png
// module id = Txrr
// module chunks = 0